import * as React from 'react';

interface IProps {
  className?: string;
}

export const Bank: React.FC<IProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
      className={className}
    >
      <path fill="#0468FF" fillOpacity="0.1" d="M0 26L32 8l32 16v8h-8v40h8v8H0v-8h8V32H0v-6z" />
      <path fill="#0468FF" d="M24 44H80V80H24z" />
      <path fill="#fff" fillRule="evenodd" d="M74 50H30v24h44V50zm-46-2v28h48V48H28z" clipRule="evenodd" />
      <path
        fill="#fff"
        d="M50.134 70v-2.992H48.22v-1.43h1.914V63.62H48.22v-1.672h1.914v-7.656h4.136c1.921 0 3.344.389 4.268 1.166.939.777 1.408 1.907 1.408 3.388 0 1.496-.506 2.67-1.518 3.52-1.012.836-2.5 1.254-4.466 1.254h-1.848v1.958h3.63v1.43h-3.63V70h-1.98zm1.98-8.052h1.562c1.335 0 2.369-.22 3.102-.66.748-.44 1.122-1.232 1.122-2.376 0-.997-.308-1.738-.924-2.222-.616-.484-1.577-.726-2.882-.726h-1.98v5.984z"
      />
    </svg>
  );
};

Bank.displayName = 'Bank';
